import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {delay, map} from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataformService {

  constructor(private readonly http: HttpClient) {
  }

  /**
   *
   * @param params
   * @returns
   */
  public validateAccessUser(params: any) {
    return this.http.get(`${environment.api_url_base_validate_access}/basic/validateAccessUser`, {params: params})
      .pipe(map(data => data));
  }



  /**
   *
   * @param params
   * @returns
   */
  listComponent(params: any) {
    return this.http.get(`${environment.api_url_base_dataform_component}/listComponent`, {params: params})
      .pipe(map(data => data));
  }

  /**
   *
   * @param params
   * @returns
   */
  listComponentAttribute(params: any) {
    return this.http.get(`${environment.api_url_base_dataform_component}/listComponentAttribute`, {params: params})
      .pipe(map(data => data));
  }

  /**
   *
   * @param params
   * @returns
   */
  getComponentAttributeList(params: any) {
    return this.http.get(`${environment.api_url_base_dataform_component}/getComponentAttributeList`, {params: params})
      .pipe(map(data => data));
  }

  /**
   *
   * @param params
   * @returns
   */
  saveComponentDetail(params: any) {
    return this.http.post(`${environment.api_url_base_dataform_component}/saveComponentDetail`, params, {observe: 'response'}).pipe(map(data => data));
  }

  getLocations(params: any) {
    return this.http.post(`${environment.api_url_base_dataform_component}/postComponent`, params, {observe: 'response'}).pipe(map(data => data));
  }

  downloadTemplate(requestBody: any) {
    return this.http.post(`${environment.api_url_base_dataform_component}/downloadFile`, requestBody).pipe(map(data => data));
  }


  uploadAndProcessFile(projectId: number, componentDet: number, prevLoteId: number, user: string, file: File, language: string) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.api_url_base_dataform_component}/processFile/${projectId}/${user}/${componentDet}/${prevLoteId}/${language}`, formData)
      .pipe(map(data => data));
  }


}
